// API configuration for production
const config = {
  API_URL: 'https://educonnect-backend-2sj8.onrender.com'
};

export default config;

